/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Tabmembers2Inputs */

const zh_organizationsettings_tabmembers2 = /** @type {(inputs: Organizationsettings_Tabmembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成员`)
};

const en_organizationsettings_tabmembers2 = /** @type {(inputs: Organizationsettings_Tabmembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const es_organizationsettings_tabmembers2 = /** @type {(inputs: Organizationsettings_Tabmembers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Organizationsettings_Tabmembers2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_tabmembers2 = /** @type {((inputs?: Organizationsettings_Tabmembers2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Tabmembers2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_tabmembers2(inputs)
	if (locale === "en") return en_organizationsettings_tabmembers2(inputs)
	return es_organizationsettings_tabmembers2(inputs)
});
export { organizationsettings_tabmembers2 as "organizationSettings_tabMembers" }